import {Movable} from "./feature/movable.feature";
import {Comparable} from "./feature/comparable.feature";
import {Rotatable} from "./feature/rotatable.feature";
import {Scalable} from "./feature/scalable.feature";
import {Euler, Matrix4, Quaternion, Scene, Vector3} from "three";
import {Extendable} from "./feature/extendable.feature";
import {Insertable} from "./feature/insertable.feature";
import {Injector} from "@angular/core";

/**
 * Base class for all features. This is provided to ease the implementation of the features and usage of the features
 * Since Mixin logic does not provide attribute mapping for IDE language servers, this class is used to provide the
 * attribute mapping for the features, incorrect use of attributes will throw an error for unimplemented methods
 */
export class FeatureBase implements
    Movable,
    Comparable,
    Rotatable,
    Scalable,
    Extendable,
    Insertable
{

    protected name: string = "";

    constructor(name: string) {
        this.name = name;
    }

    get scale(): Vector3 {
        throw new Error('Method not implemented for: ' + this.name);
    }

    set scale(value: Vector3) {
        throw new Error('Method not implemented for: ' + this.name);
    }

    set rotation(value: any) {
        throw new Error('Method not implemented for: ' + this.name);
    }

    get rotation(): Euler | never {
        throw new Error('Method not implemented for: ' + this.name);
    }

    set position(value: any) {
        throw new Error('Method not implemented for: ' + this.name);
    }

    get position(): Vector3 | never {
        throw new Error('Method not implemented for: ' + this.name);
    }

    get worldPosition(): Vector3 | never {
        throw new Error('Method not implemented for: ' + this.name);
    }

    set matrixWorld(value: any) {
        throw new Error('Method not implemented for: ' + this.name);
    }

    get matrixWorld(): Matrix4 {
        throw new Error('Method not implemented for: ' + this.name);
    }

    set matrix(value: any) {
        throw new Error('Method not implemented for: ' + this.name);
    }

    get matrix(): Matrix4 {
        throw new Error('Method not implemented for: ' + this.name);
    }

    extend(object: any): void {
        throw new Error('Method not implemented for: ' + this.name);
    }

    insert(scene: Scene): void {
        throw new Error('Method not implemented for: ' + this.name);
    }

    get size(): Vector3 {
        throw new Error('Method not implemented for: ' + this.name);
    }

    get center(): Vector3 {
        throw new Error('Method not implemented for: ' + this.name);
    }

    computeBoundingBox(): void {
        throw new Error('Method not implemented for: ' + this.name);
    }

}